import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=0051a1e2"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"
import style0 from "./Switch.vue?vue&type=style&index=0&id=0051a1e2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0051a1e2')) {
      api.createRecord('0051a1e2', component.options)
    } else {
      api.reload('0051a1e2', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=0051a1e2", function () {
      api.rerender('0051a1e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Switch/Switch.vue"
export default component.exports